/**
 * @generated SignedSource<<e4e224ad57aca4482f9ae6fee78884c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetContactPreferredLanguageInput = {
  id: string;
  preferredLanguage?: string | null | undefined;
};
export type SetContactPreferredLanguageDialogMutation$variables = {
  input: SetContactPreferredLanguageInput;
};
export type SetContactPreferredLanguageDialogMutation$data = {
  readonly setContactPreferredLanguage: {
    readonly id: string;
    readonly preferredLanguage: string | null | undefined;
  };
};
export type SetContactPreferredLanguageDialogMutation = {
  response: SetContactPreferredLanguageDialogMutation$data;
  variables: SetContactPreferredLanguageDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredLanguage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetContactPreferredLanguageDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "setContactPreferredLanguage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetContactPreferredLanguageDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "setContactPreferredLanguage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "098780e8c270cbfc3a38704e705597e1",
    "id": null,
    "metadata": {},
    "name": "SetContactPreferredLanguageDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SetContactPreferredLanguageDialogMutation(\n  $input: SetContactPreferredLanguageInput!\n) {\n  setContactPreferredLanguage(input: $input) {\n    __typename\n    id\n    preferredLanguage\n  }\n}\n"
  }
};
})();

(node as any).hash = "4812e72e5ffae1e65a75a220411fd3a8";

export default node;
